"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function PaperPlane16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.6213 3.96458L3.19158 7.14874L5.84505 8.74082L10.6213 3.96458ZM7.25926 10.155L8.85131 12.8085L12.0354 5.3789L7.25926 10.155ZM15.7222 1.8535C16.1489 0.857831 15.1422 -0.148893 14.1466 0.277821L0.965648 5.92678C0.06588 6.31239 -0.0184675 7.55509 0.820956 8.05874L5.27117 10.7289L7.9413 15.1791C8.44496 16.0185 9.68765 15.9342 10.0733 15.0344L15.7222 1.8535Z", fill: "#131416" }));
}
function PaperPlane16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(PaperPlane16Svg, Object.assign({}, svgProps)));
}
exports.default = PaperPlane16;
//# sourceMappingURL=PaperPlane16.js.map